import * as jsxRuntime from "/home/runner/work/aktify-user-interface/aktify-user-interface/namespaces/admin.aktify.io/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment